import { type FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useSportUrlParams } from '@mwl/core-lib';
import WarningIcon from '@public/assets/common/icons/warningIcon.svg';
import type { MessageClasses } from '@/components/Message/Message';
import { Message } from '@/components/Message/Message';
import { routes } from '@/constants';
import type { MessageEmptyLinesProps } from './MessageEmptyLines.types';
import styles from './MessageEmptyLines.module.scss';
const messageClasses: MessageClasses = {
  iconWrapper: styles.iconWrapper
};
export const MessageEmptyLines: FC<MessageEmptyLinesProps> = ({
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const {
    stage
  } = useSportUrlParams();
  const subtitle = useMemo(() => {
    if (stage === 'PREGAME') {
      return t('sport.lines.pregame_no_lines', 'There is no pregame match at this time');
    }
    if (stage === 'OUTRIGHT') {
      return t('sport.lines.outright_no_lines', 'There is no outright at this time');
    }
    return t('sport.lines.live_no_lines', 'There is no live match at this time');
  }, [stage, t]);
  return <Message buttonText={t('sport.to_home_page', 'To sport home page')} className={cn(styles.root, className)} buttonProps={{
    as: 'link',
    href: {
      pathname: routes.sport.home
    },
    color: 'white',
    fullWidth: false
  }} icon={<WarningIcon />} classes={messageClasses} data-sentry-element="Message" data-sentry-component="MessageEmptyLines" data-sentry-source-file="MessageEmptyLines.tsx">
      {subtitle}
    </Message>;
};